import { snakeCase } from 'lodash';

import { IStateAutocomplete } from 'addresses/types';

import { ContactGroupAddressType } from './enums';
import { IQuoteAddressForm, IQuoteAddressType } from './types';

export const mapUpdateContactGroupAddressForm = (
  data: IQuoteAddressForm,
  accountsReceivableId: string,
  type: ContactGroupAddressType
): IQuoteAddressType => {
  const { address } = data;
  const { state } = address;

  return {
    address: {
      line1: address?.line1,
      line2: address?.line2,
      city: address?.city,
      country: address?.country?.abbreviation,
      name: address?.name,
      state: (state as IStateAutocomplete)?.id?.toString() || (state as string),
      zip: address?.zip,
      accountsReceivableId: accountsReceivableId,
      contactName: data?.contactName,
      contactPhone: data?.contactPhone,
      contactEmail: data?.contactEmail,
      contactCompanyName: data?.contactCompanyName,
    },
    addressType: snakeCase(type),
  };
};
